export default __webpack_public_path__ + "static/media/audioicon@2x.333e5868.png";